import { Report } from 'types/research';
import { RootState } from 'store/index';

export const selectResearch = (state: RootState): Report[] | null => state.research.reports;

export const selectResearchIsLoading = (state: RootState): boolean => state.research.isLoading;
